import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {ButtonToolbar, Dropdown} from "react-bootstrap"

import id from "@irati/utils/id"
import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

import {withHandleAction} from "../../components/Schedule/Actions/HandleAction"

import ListItem from "./ListItem"

export const DropdownMenu = styled(Dropdown.Menu)`
  border: none;
  padding: 0;
  ${({theme}) => theme.shadows.high};
  margin-top: 10px;
  margin-bottom: 10px !important;
  min-width: max-content;
  & > li > a {
    padding: 0;
  }
`

export const StyledButtonToolbar = styled(ButtonToolbar)`
  margin-left: 0;
`

class Menu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  static propTypes = {
    label: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        action: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
      })
    ).isRequired,
    pullRight: PropTypes.bool,
    className: PropTypes.string,
    slim: PropTypes.bool
  }

  static defaultProps = {
    label: undefined,
    pullRight: false,
    className: undefined,
    slim: false
  }

  toggle = () => {
    this.setState({open: !this.state.open})
  }

  render() {
    const {label, items, pullRight, className} = this.props
    const idNamespace = id("menu", this.props)
    const {open} = this.state
    const WrappedListItem = withHandleAction(ListItem)
    return (
      <StyledButtonToolbar className={className}>
        <Dropdown
          id={id("insights-menu", idNamespace)}
          title={label}
          open={open}
          onToggle={this.toggle}
          pullRight={pullRight}
          componentClass="div">
          {label ? (
            <Button tertiary bsRole="toggle">
              {label}
              <Icon icon={open ? IconTypes.chevronUp : IconTypes.chevronDown} marginLeft />
            </Button>
          ) : (
            <Button bsRole="toggle" testing="true" icon={IconTypes.more} />
          )}
          <DropdownMenu bsRole="menu">
            {items.map((item, key) => (
              <WrappedListItem item={item} id={id(item.icon, idNamespace)} bsRole="menuitem" key={key} label={item.label} />
            ))}
          </DropdownMenu>
        </Dropdown>
      </StyledButtonToolbar>
    )
  }
}

export default Menu
